/* global axios */
import ApiClient from './ApiClient';

class TalkviaManualSimulatorsAPI extends ApiClient {
  constructor() {
    super('talkvia_manual_simulators', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  banks(params = {}) {
    return axios.get(`${this.url}/banks`, { params });
  }

  create(data) {
    return axios.post(this.url, { talkvia_manual_simulator: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { talkvia_manual_simulator: data });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new TalkviaManualSimulatorsAPI();
